module.exports = __webpack_public_path__ + "static/media/IMG_0011.6bc55dbe.jpg";